import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'
import { Col } from 'styled-bootstrap-grid'

import { spacing } from '@vfuk/core-mixins'

import type { StyledGridColumnProps } from './GridColumn.style.types'

export const GridColumn = styled(Col)(
  (props: StyledGridColumnProps): FlattenSimpleInterpolation => css`
    ${props.autoMargin &&
    `
    margin-${props.autoMargin}: auto;
  `}

    ${props.marginTop && spacing('margin-top', props.marginTop)}

  ${props.marginBottom && spacing('margin-bottom', props.marginBottom)}
  `,
)
